<script lang="ts">
    import { api, ApiError } from '../lib/api';
    import { auth } from '../lib/stores/auth.svelte';
    import { toast } from '../lib/stores/toast.svelte';
    import { t } from '../lib/i18n.svelte';

    let username = $state('');
    let password = $state('');
    let loading = $state(false);

    async function submit(e: SubmitEvent) {
        e.preventDefault();
        loading = true;
        try {
            const res = await api<{ token: string }>('/auth/login', {
                method: 'POST',
                body: JSON.stringify({ username, password }),
            });
            auth.login(res.token, username);
            toast.success('Welcome back!');
        } catch (err) {
            const msg = err instanceof ApiError ? err.message : 'Login failed';
            toast.error(msg);
        } finally {
            loading = false;
        }
    }
</script>

<div class="wrap">
    <form class="card login" onsubmit={submit}>
        <!-- RB-B3 (SP-103): stacked brand lockup — company line 1, app
             name line 2, NB tagline below (public surface only per D-10). -->
        <div class="brand-lockup">
            <div class="mark">
                <img src="/brand/SQUARE1.png" alt={t('login.logo_alt', { en: 'Sprezzatura logo', nb: 'Sprezzatura-logo' })} />
            </div>
            <h1>Sprezzatura</h1>
            <p class="app-name">KeyVault</p>
            <p class="tagline">- administrasjon for idretten</p>
        </div>
        <p class="muted">Sign in with admin credentials</p>

        <label>
            Username
            <input bind:value={username} autocomplete="username" required />
        </label>

        <label>
            Password
            <input type="password" bind:value={password} autocomplete="current-password" required />
        </label>

        <button class="primary" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
        </button>
    </form>
</div>

<style>
    .wrap {
        height: 100vh; display: flex; align-items: center; justify-content: center;
        background: radial-gradient(ellipse at top, #1e293b, var(--bg-0));
    }
    .login { width: 360px; display: flex; flex-direction: column; gap: 14px; }
    .brand-lockup { display: flex; flex-direction: column; align-items: center; gap: 2px; margin-bottom: 6px; }
    .brand-lockup .mark { width: 64px; height: 64px; display: flex; align-items: center; justify-content: center; overflow: hidden; border-radius: 12px; background: #000; box-shadow: 0 1px 2px rgb(0 0 0 / 0.1); margin-bottom: 8px; }
    .brand-lockup .mark img { width: 48px; height: 48px; object-fit: contain; }
    .brand-lockup h1 { margin: 0; font-size: 1.875rem; line-height: 1.2; }
    .brand-lockup .app-name { margin: 0; font-weight: 600; color: var(--accent, #4f79ff); }
    .brand-lockup .tagline { margin: 4px 0 0; font-size: 0.75rem; opacity: 0.5; }
    h1 { margin: 0; }
    label { display: flex; flex-direction: column; gap: 6px; font-size: 13px; }
</style>